"use client"

export const getProfile = async (setProfile, token) => {

  const authData = {
    action: 'getProfile',
    token: token,
  };

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(authData)
  };

  fetch('https://lk.kapmed.ru/ini', options)
    .then(response => response.json())
    .then(data => {
      localStorage.setItem('profile', JSON.stringify(data))
      setProfile('1')
    })
    .catch(error => {
      
    });
}

export const getAuth = async (setLoading, setResult, setChecked, login, secret) => {
  setLoading(true)
  setResult(null)
  const authData = {
    action: 'login',
    phone: login,
    password: secret
  };

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(authData)
  };
  fetch('https://lk.kapmed.ru/users', options)
    .then(response => response.json())
    .then(data => {
      switch (data.status) {
        case 'ok':
          if (data.agreement == 1) {
            // setLoading(false)
            localStorage.setItem('token', data.token)
            window.location.replace("https://lk.kapmed.ru/auth/polis")
            break;
          } else {
            setLoading(false)
            setChecked(true)
            localStorage.setItem('token', data.token)
            break;
          }

        case 'error':
          setResult('Неверный логин или пароль')
          setLoading(false)
          break;
      }

    })
    .catch(error => console.error(error));
}

export const setAgreements = async () => {
  const authData = {
    action: 'setAgreement',
    token: localStorage.getItem('token')
  };

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(authData)
  };
  fetch('https://lk.kapmed.ru/ini', options)
    .then(response => response.json())
    .then(data => {
      if (data.status == 'ok') { window.location.replace("https://lk.kapmed.ru/auth/polis") }

    })
    .catch(error => console.error(error));
}

export const getRegister = async (setLoading, setResult, setChecked, region, fam, im, ot, phone, snils, email, password, passwordk, setOTP) => {

  setLoading(true)

  const authData = {
    action: 'register',
    region: region,
    lastname: fam,
    firstname: im,
    ot: ot,
    snils: snils,
    email: email,
    phone: phone,
    password: password,
    password_confirm: passwordk
  };

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(authData)
  };
  fetch('https://lk.kapmed.ru/users', options)
    .then(response => response.json())
    .then(data => {
      switch (data.status) {
        case 'ok':
          if (data.agreement == 1) {
            setLoading(false)

            console.log(data.input)
            break;
          } else {
            setLoading(false)
            setOTP(true)
            break;
          }

        case 'error':
          setLoading(false)
          setResult(data.input)
          break;
      }

    })
    .catch(error => console.error(error));
}

export const getZl = (setLoading, setData, setInit) => {
  setLoading(true)
  setInit('Загрузка...')
  let token = localStorage.getItem('token')


  const authData = {
    action: 'zl',
    token: token,
  };

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(authData)
  };

  fetch('https://lk.kapmed.ru/ini', options)
    .then(response => response.json())
    .then(data => {
      setData(data)
      setLoading(false)
      localStorage.setItem('polis', JSON.stringify(data))
      if (data.status == 'false') { setInit('Полисы не обнаружены') } else { setInit('Ваш полис и полисы ваших детей') }

    })
    .catch(error => {
      //setData(data)
      setLoading(false)

    });

}

export const sms_confirmation = (setLoading, setData, email, sms_code) => {
  setLoading(true)


  const authData = {
    action: 'sms_confirmation',
    email: email,
    sms_code: sms_code,
  };

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(authData)
  };

  fetch('https://lk.kapmed.ru/users', options)
    .then(response => response.json())
    .then(data => {
      setData(data)
      setLoading(false)
      if (data.status == 'ok') {
        window.location.replace("https://lk.kapmed.ru/login")
      }
    })
    .catch(error => { console.log(error) });

}

export const smsPasswordReset = async (setLoading, setStatus, phone) => {
  setLoading(true);
  const authData = {
    action: 'smsPasswordReset',
    phone: phone
  };

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(authData)
  };

  fetch('https://lk.kapmed.ru/ini', options)
    .then(response => response.json())
    .then(data => {
      switch (data.status) {
        case 'ok':
          setLoading(false)
          setStatus(true)
          break;
        case 'error':
          setLoading(false)
          setStatus(true)
          break;
      }

    })
    .catch(error => console.error(error));
}

export const smsPasswordResetConfirm = async (setLoading, setData, phone, SMS) => {
  setLoading(true);
  const authData = {
    action: 'smsPasswordResetConfirm',
    phone: phone,
    smsСode: SMS
  };

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(authData)
  };
  fetch('https://lk.kapmed.ru/ini', options)
    .then(response => response.json())
    .then(data => {
      switch (data.status) {
        case 'ok':
          setLoading(false)
          setData(data)
          break;
        case 'false':
          setLoading(false)
          setData(data)
          break;
      }

    })
    .catch(error => console.log(''));
}

export const PasswordReset = async (setLoading, phone, smsCode, password) => {
  setLoading(true);
  const authData = {
    action: 'PasswordReset',
    phone: phone,
    smsСode: smsCode,
    password: password
  };
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(authData)
  };

  fetch('https://lk.kapmed.ru/ini', options)
    .then(response => response.json())
    .then(data => {
      switch (data.status) {
        case 'ok':
          setLoading(false)
          window.location.replace("https://lk.kapmed.ru/login")
          break;
        case 'error':
          setLoading(false)
          break;
      }

    })
    .catch(error => console.error(error));
}

export const getPolisDetail = async (setLoading, setData, tok, ENP) => {

  setLoading(true);
  const authData = {
    action: 'zl_detail',
    token: tok,
    ENP: ENP
  }


  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(authData)
  }

  fetch('https://lk.kapmed.ru/ini', options)
    .then(response => response.json())
    .then(data => {
      setData(data)
      setLoading(false)
    })
    .catch(error => console.error(error));
}

export const getLpuDetail = async (setLoading, setLPUData, tok, LPU, setSrc) => {

  setLoading(true);
  const authData = {
    action: 'getLpuDetail',
    token: tok,
    LPU: LPU
  }


  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(authData)
  }

  fetch('https://lk.kapmed.ru/ini', options)
    .then(response => response.json())
    .then(data => {
      setLPUData(data.data)

      if (typeof data.data !== 'undefined') {setSrc('https://lk.kapmed.ru/mobapp/lpu.php?data=[{"longitude":"'+data.data.lng+'", "latitude":"'+data.data.lat+'"}]')}
      
      setLoading(false)
    })
    .catch(error => console.error(error));
}

export const ListObr = async (setLoading, setData, setInit) => {
  let token = localStorage.getItem('token')
  setLoading(true)
  setInit('Загрузка...')
  setData([])

  const authData = {
    action: 'get_obr',
    token: token,
  };

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(authData)
  };

  fetch('https://lk.kapmed.ru/ini', options)
    .then(response => response.json())
    .then(data => {
      if (data.status !== 'false') {
        setLoading(false)
        setInit('')
        setData(data)
        localStorage.setItem('obrs', JSON.stringify(data))
      } else {
        setLoading(false)
        setInit('Обращений не найдено')
      }
    })
    .catch(error => { console.log(error) })
}

export const addObr = async (setLoading, form, comment, assets) => {
  setLoading(true)
  let token = localStorage.getItem('token')

  const files = assets ? [...assets] : [];

  const data = new FormData();
  data.append('action', 'addObr')
  data.append('token', token as string)
  data.append('form', form as string)
  data.append('comment', comment as string)
  files.forEach((file, i) => {
    data.append(`file_v[${i}]`, file, file.name);
  });

  const authData = {
    action: 'addObr',
    token: token,
    form: form,
    comment: comment,
    assets: assets
  };

  const options = {
    method: 'POST',
    body: data
  };

  fetch('https://lk.kapmed.ru/obr', options)
    .then(response => response.json())
    .then(data => {
      if (data.status == 'OK') {
        setLoading(false)
        window.location.replace("https://lk.kapmed.ru/auth/obrs")
      }

    })
    .catch(error => {
      setLoading(false)
    });
}
